import React from 'react'
import imge from '../../img/pexels-photo-298863.jpeg'
import imges from '../../img/pexels-photo-356056.jpeg'
import imges1 from '../../img/pexels-photo-1927259.webp'
import imges2 from '../../img/pexels-photo-7679720.jpeg'
export default function About() {


 

  return <>
  
  <div className="container my-5">
      {/* About Us Section */}
        {/* عنوان قسم المنتجات الأحدث */}
        <div className="container text-center py-5">
            <h1>About Us</h1>
            <hr />
        </div>
      <p className="text-center">
        Lorem ipsum dolor sit amet consectetur adipiscing elit. Nostrum facere doloremque veritatis odit similique sequi. Odit amet fuga nam quam quasi facilis sed doloremque saepe sint perspiciatis explicabo totam vero quas provident ipsum, veritatis nostrum velit qui recusandae est mollitia esse fugit dolore laudantium. Ex vel explicabo earum unde eligendi autem praesentium, doloremque distinctio nesciunt porro tempore quis eaque labore voluptatibus ea necessitatibus exercitationem tempora molestias. Ad consequuntur veniam sequi ullam tempore vel tenetur soluta dolore sunt maxime aliquam corporis est, quo saepe dolorem optio minus sint nemo totam dolorum! Reprehenderit delectus expedita alias nam recusandae illo debitis repellat libero, quasi explicabo molestiae saepe, dolorem tempore itaque eveniet quam dignissimos blanditiis excepturi harum numquam vel nihil? Ipsum...
      </p>

      {/* Our Products Section */}
      <h2 className="text-center my-5">Our Products</h2>
      <div className="row row-cols-1 row-cols-md-4 g-4">
        {/* Add your product cards here */}
        <div className="col">
          <div className="card h-100">
            <img src={imge} className="card-img-top" alt="Men's Clothing" />
            <div className="card-body text-center">
              <p className="card-text">Men's Clothing</p>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card h-100">
            <img src={imges2}className="card-img-top" alt="Women's Clothing" />
            <div className="card-body text-center">
              <p className="card-text">Women's Clothing</p>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card h-100">
            <img src={imges1} className="card-img-top" alt="Jewelry" />
            <div className="card-body text-center">
              <p className="card-text">Jewelry</p>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card h-100">
            <img src={imges} className="card-img-top" alt="Electronics" />
            <div className="card-body text-center">
              <p className="card-text">Electronics</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </>
}
